(() => {
  const header = document.querySelector('[data-kyvo-header]');
  if (header) {
    const toggle = header.querySelector('[data-menu-toggle]');
    const menu = header.querySelector('[data-menu]');
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }));
    }
  }

  document.querySelectorAll('[data-kyvo-quantity]').forEach((qty) => {
    const input = qty.querySelector('input');
    const minus = qty.querySelector('[data-qty-minus]');
    const plus = qty.querySelector('[data-qty-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => { input.value = String(Math.max(1, Number(input.value || 1) - 1)); });
    plus?.addEventListener('click', () => { input.value = String(Math.min(99, Number(input.value || 1) + 1)); });
  });

  document.querySelectorAll('[data-kyvo-product-form]').forEach((container) => {
    const form = container.querySelector('form');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]');
    form.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantId && radio.checked) variantId.value = radio.value;
      });
    });

    form.addEventListener('submit', (event) => {
      const hasVehicleLookup = Boolean(document.querySelector('[data-vrm-section]'));
      const make = form.querySelector('[data-line-property="make"]')?.value.trim();
      const model = form.querySelector('[data-line-property="model"]')?.value.trim();
      const year = form.querySelector('[data-line-property="year"]')?.value.trim();
      if (hasVehicleLookup && (!make || !model || !year)) {
        event.preventDefault();
        const root = document.querySelector('[data-vrm-section]');
        const status = root?.querySelector('[data-vrm-status]');
        if (status) {
          status.className = 'kyvo-vrm-status is-error';
          status.textContent = 'Please select your vehicle before adding the sensor to your basket.';
        }
        root?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => root?.querySelector('[data-vrm-input]')?.focus(), 350);
      }
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const media = thumb.closest('.kyvo-product__media');
      const mainImage = media?.querySelector('.kyvo-product__main-image img');
      const src = thumb.getAttribute('data-image-src');
      if (mainImage && src) {
        // Shopify's image_tag outputs a responsive srcset. Remove it when a
        // thumbnail is selected so the browser cannot keep displaying the
        // previously selected responsive source instead of the new image.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
      }
      media?.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumb));
    });
  });

  document.querySelectorAll('[data-change-vehicle]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector('[data-vrm-section]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => document.querySelector('[data-vrm-input]')?.focus(), 400);
    });
  });
})();
